"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toStorage = (storage = window.localStorage) => (storageName, encode) => (value) => {
    const encodedValue = encode(value);
    storage.setItem(storageName, encodedValue);
    return encodedValue;
};
exports.default = toStorage;
